'use client';

import * as React from 'react';
import { useRoomContext, useLocalParticipant } from '@livekit/components-react';
import { useReactions, ReactionType } from './ReactionsContext';

export function ReactionsListener() {
  const room = useRoomContext();
  const localParticipant = useLocalParticipant();
  const { addReaction } = useReactions();

  React.useEffect(() => {
    if (!room) return;

    const handleDataReceived = (payload: Uint8Array, participant?: any) => {
      try {
        const data = JSON.parse(new TextDecoder().decode(payload));

        if (data.type === 'reaction') {
          const currentUserIdentity = localParticipant.localParticipant?.identity;

          // Ignora reações do próprio usuário (já foram adicionadas localmente)
          if (data.participantId === currentUserIdentity) {
            return;
          }

          // Adiciona a reação recebida
          addReaction({
            id: `${data.participantId}-${data.timestamp}`,
            type: data.reaction as ReactionType,
            participantId: data.participantId,
            participantName: data.participantName || data.participantId,
            timestamp: data.timestamp || Date.now(),
          });
        }
      } catch (error) {
        // Ignora erros de parsing, pode ser outro tipo de mensagem
      }
    };

    room.on('dataReceived', handleDataReceived);

    return () => {
      room.off('dataReceived', handleDataReceived);
    };
  }, [room, localParticipant, addReaction]);

  return null;
}
